import React from 'react';
import ProductStudioPage from './ProductStudioPage';

const ProductToImage: React.FC = () => <ProductStudioPage />;

export default ProductToImage;
